import { map } from 'rxjs/operators';
import ApiService from './api';

export default class CustomerService extends ApiService {
  constructor(config) {
    super(config);

    this.baseURL = `${this.baseURL}/customer`;
  }

  getLogo() {
    return this.fetchResource('/logo');
  }
}
